module.exports = __webpack_public_path__ + "static/img/power1.4a6ecae4.png";